export const DEFAULT_FAQS = [
    {
        id: 1,
        question: "Necessary",
        categories: 1,
        option: [
            {
                id: 1,
                label: "Original registration certificate",
                answer: "Registration Certificate helps us verify details of the car and is also necessary for the transfer of ownership." +
                "In case the RC is not available, we need to get a duplicate RC from RTO, which occurs at some cost and might impact the car value"
            },
            {   id: 2,
                label: "PAN card of registered owner",
                answer: "PAN Card validates the signature of an individual against his/her name and photograph." +
                "This helps to corroborate the identity of seller against the name in the RC and also owner’s signature on ownership transfer forms (Form 28/ 29/ 30). PAN card is mandatory for the payment."
            },
            {   id: 3,
                label: "KYC of registered owner",
                description: " (Aadhar card OR Passport OR Voter ID of registered owner)",
                answer: "KYC of the registered owner is required during the ownership transfer. Presenting" +
                "these documents at the time of sale of a car builds confidence in the buyer about the seller’s identity."
            },
            {   id: 4,

                label: "KYC Of Seller",
                description: " (Third Party Transaction Only)",
                answer: "KYC of the person selling the car would also required, wherein the sale is being done by a third party on behalf of the registred owner." +
                "These details builds confidence in the buyer about the authenitisity of transaction. "
            }
        ]
    },
    {
        id: 2,
        question: "To ensure instant payment",
        categories: 1,

        option: [
            {   id: 1,

                label: "4 self attested passport size photographs of registered owner",
                answer: "Photographs of the registered owner needs to be presented with the forms at RTO during the transfer of ownership." +
                " (For Non-Individual Owners are Director/Partner/Authorised Person)"
            },
            {   id: 2,

                label: "Cancelled cheque of registered owner/Bank details with IMPS facility",
                answer: "To enable the safe transaction to the customer's bank account we need either bank details of the registered owner where the IMPS facility is available or a canceled cheque is required" +
                " which has the individual's bank details (Bank Account Number, Branch, IFSC Code of the Branch and Name of the Account Holder as specified in bank records)"
            }
        ]
    },
    {
        id: 3,
        question: "Documents for financed cars",
        answer: "Please refer to the link to know more about how to issue the Letter, NOC and form 35. <a href='https://www.cars24.com/blog/car-loan-closure-procedure-at-all-banks/' target='_blank'>https://www.cars24.com/blog/car-loan-closure-procedure-at-all-banks/</a>'",
        categories: 2,
        option: [
            {
                id: 1,
                label: "For existing loans/ hypothecations",
                subOption: [
                    {
                        id: 1,
                        label: "Loan foreclosure letter",
                        answer: "Loan Forclosure certificate provides the details of loan account, EMIs paid and outstanding balance hence it will help us confirm and clear the balance amount to the bank/finance institution."
                    }
                ]
            }, {
                id: 2,
                label: "For closed loans:",
                subOption: [
                    {
                        id: 1,
                        label: "Loan closure certificate or NOC",
                        answer: "NOC is issued by the financier and required for the removal of hypothecation from the Registration certificate. The absence of NOC might delay the process of ownership transfer as to Issue a NOC might take some time."
                    }, {
                        id: 2,
                        label: "2 copies of Form 35",
                        answer: "Form 35 is required for removal of hypothecation from Registration certificate if hypothecation is endorsed in RC."
                    }
                ]
            }
        ]
    },
    {
        id: 4,
        question: "To ensure the best price",
        categories: 1,
        option: [
            {   id: 1,
                label: "Insurance certificate or policy",
                answer: "Insurance certificate is necessary to check the Insurance type (Comprehensive/Third Party/Zero depreciation). Minimum Third party Insurance is required during the transfer of ownership.Car with comprehensive/Zero depreciation insurance gets more value."
            },
            {   id: 2,
                label: "Spare keys",
                answer: "Car with the Spare key attracts more value hence it is recommended to present duplicate key along with original key at the time of sale to get better value for the car."
            },
            {   id: 3,
                label: "Service history",
                answer: "A transparent presentation of service records and information ( Service Manual) to the buyer about car’s maintenance always attracts better value as it gives confidence to the buyer about how well the car has been maintained by the owner."
            },
            {   id: 4,
                label: "Extended warranty certificate",
                answer: "A car with extended warranty cover always attracts better value as it gives confidence to the buyer that the car is well maintained and any repairs of the warranty covered parts in future can be done free of cost. This provides peace of mind from extra burden of repair maintenance expense."
            },
            {   id: 5,
                label: "Original invoice",
                answer: "An original invoice establishes the authenticity. In case details are mismatch on RC/Vahan, Original invoice is referred and hence allows for the best price discovery."
            },
            {   id: 6,
                label: "CNG/LPG certificate",
                answer: "Only applicable for cars wherein CNG/LPG kit are fitted. This is required for safety purpose and also required for RC transfer. Car with no certifcate attracts less value as buyer needs to get registration done from Government Authorised Fitment center."
            }
        ]
    },
    {
        id: 5,
        question: "Additional documents if car is not owned by an individual",
        categories: 2,
        option: [
            {
                id: 1,
                label: "Proprietorship",
                subOption: [
                    {   id: 1,
                        label: "GST/DVAT Certificate",
                        answer: "GSTIN Registration Certificate is issued under the GST law when a Firm / Company / HUF gets GST registered. You require this certificate while selling your car only if your car's RC is in the name of the Firm / Company / HUF etc." +
                        "This is needed because the GST law mandates the buyer to check whether the transaction is being done with a GST registered business."
                    },
                    {   id: 2,
                        label: "Letterhead",
                        answer: "Letterhead is required to intiate the transfer of ownership." +
                        "This document act as a proof at the RTO that firm/organization has sold their car and hence requesting for the transfer."
                    }
                ]
            },
            {   id: 2,
                label: "Partnership",
                subOption: [
                    {
                        id: 1,
                        label: "Partnership deed",
                        answer: "A deed is required to check if the seller is among the patners or he/she have the authority to sell out the car."
                    },
                    {   id: 2,
                        label: "KYC Of Partners",
                        answer: "KYC of the all the partners is required during the ownership transfer. Presenting these documents at the time of sale of a car builds confidence in the buyer about the seller’s identity."
                    },
                    {   id: 3,
                        label: "Letterhead",
                        answer: "Letterhead is required to intiate the transfer of ownership. This document act as a proof at the RTO that firm/organization has sold their car and hence requesting for the transfer."
                    },
                    {   id: 4,
                        label: "NOC/Authorisation Letter",
                        answer: "NOC/Authorization letter (on Partnership's letterhead) act as proof that person selling the car is authorised by the partners to do so.This letter needs to signed by all the partners and should contain partnership's stamp. "
                    }
                ]
            },
            {
                id: 3,
                label: "Pvt Ltd Company",
                subOption: [
                    {
                        id: 1,
                        label: "MOA",
                        answer: "MOA act as the KYC of the organization and helps to check the details like director, registration certificate."
                    },
                    {   id: 2,
                        label: "GST certificate",
                        answer: "GSTIN Registration Certificate is issued under the GST law when a Firm / Company / HUF gets GST registered. You require this certificate while selling your car only if your car's RC is in the name of the Firm / Company / HUF etc. This is needed because the GST law mandates the buyer to check whether the transaction is being done with a GST registered business."
                    },
                    {   id: 3,
                        label: "Letterhead",
                        answer: "Letterhead is required to intiate the transfer of ownership. This document act as a proof at the RTO that firm/organization has sold their car and hence requesting for the transfer."
                    },
                    {   id: 4,
                        label: "Authorisation letter",
                        answer: "Authority letter (on company's letterhead) act as proof that person selling the car is authorised by the company to do so.This letter needs to issued by the Director of the organization and should contain company's stamp."
                    }
                ]
            }
        ]
    }
];

export const BOTTOM_FAQS = [
    {
        id: 1,
        question: "How long will my car’s inspection take?",
        answer: "CARS24 evaluates a used car on the basis of several " +
            "parameters and our dedicated CJs (Car Jockeys) are trained to " +
            "complete the inspection process within 30- 45 minutes."
    },
    {
        id: 2,
        question: "Can I reschedule my appointment?",
        answer: "Yes, you can reschedule your appointment time," +
            " date or branch by clicking on ‘Edit Details’" +
            " on your appointment confirmation page." +
            " Alternately, you will receive a call from our customer support" +
            " team on the day of your appointment and " +
            "they can assist you with rescheduling your appointment."
    },
    {
        id: 3,
        question: "Will you charge me for my car’s inspection?",
        answer: "No, CARS24 inspection process at our retail branches " +
            "is absolutely free. However, we also offer Home Inspections in " +
            "certain cities in which case we charge a nominal fee of INR 299."
    },
    {
        id: 4,
        question: "My car is on loan. Will you still buy it?",
        answer: "Yes, CARS24 will be happy to buy your car" +
            " and help in loan foreclosure as well."
    }
];

export const inspectionQuestion =
    {
        "label": "Please let us know your reason for cancelling the inspection.",
        "key": "cancel_reason",
        "options": []
    };
export const REASON_NOT_LISTED = "REASON_NOT_LISTED";
